import { render, staticRenderFns } from "./AgencyProfileNeeds.vue?vue&type=template&id=ffbe88ec"
import script from "./AgencyProfileNeeds.vue?vue&type=script&lang=js"
export * from "./AgencyProfileNeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports